export const API_PATH_ApiWorkzoneItisCodesGet = '/services/workzones-management/itis-codes';
